/**
 * Class GeoTrace
 */
export default class GeoTrace {

	// This endpoint obtain the information about the user (this information includes the country code)
	static traceEndpoint = 'https://elementor.com/cdn-cgi/trace';
	// Fetch timeout ( 3 sec )
	static fetchTimeout = 3000;
	// The key name which the information from the fetch will be stored
	static storageKey = 'elGeoLocationCode';
	// Global fetch error flag
	fetchError = false;

	/**
	 * Retrieve client the location code.
	 * @returns {Promise<*|boolean>}
	 */
	async getLocationCode() {

		let storageGeoCode = GeoTrace.getFromStorage();
		if ( storageGeoCode ) {
			return storageGeoCode;
		}
		try {
			let response = await GeoTrace.fetchCloudflareCgiTrace();
			let text = await response.text();
			storageGeoCode = this.extractFromTraceEndpoint( text, 'loc' );
			GeoTrace.saveToStorage( storageGeoCode );
		} catch ( e ) {
			this.fetchError = true;
		}

		return storageGeoCode;

	}

	/**
	 * Retrieve client IP address.
	 * @returns {Promise<*|boolean>}
	 */
	async getIpAddress() {
		let ip;

		try {
			let response = await GeoTrace.fetchCloudflareCgiTrace();
			let text = await response.text();
			ip = this.extractFromTraceEndpoint( text, 'ip' );
		} catch ( e ) {
			this.fetchError = true;
		}

		return ip;
	}

	/**
	 * extractFromTraceEndpoint
	 * @param responseText
	 * @param param
	 * @return {*}
	 */
	extractFromTraceEndpoint( responseText, param ) {
		let paramValue;

		if ( responseText ) {
			paramValue = responseText.split( param + '=' )[ 1 ].split( "\n" )[ 0 ];
		} else {
			throw 'responseEmpty';
		}

		return paramValue;
	}

	/**
	 * Retrieve the client data trace.
	 * @returns {Promise<Response>}
	 */
	static async fetchCloudflareCgiTrace() {

		const controller = new AbortController();
		const timeoutId = setTimeout( () => controller.abort(), GeoTrace.fetchTimeout );

		const response = await fetch( GeoTrace.traceEndpoint, { mode: "cors" } );
		clearTimeout( timeoutId );

		return response;

	}


	/**
	 * Save the data ( geo location code ) to the local storage
	 * @param data
	 */
	static saveToStorage( data ) {

		if ( GeoTrace.isLocalStorageOn() ) {
			window.localStorage.setItem( GeoTrace.storageKey, JSON.stringify( data ) );
		}

	}

	/**
	 * Get the data from the local storage
	 * @returns {any|boolean}
	 */
	static getFromStorage() {
		return GeoTrace.isLocalStorageOn() ? JSON.parse( window.localStorage.getItem( GeoTrace.storageKey ) ) : false;
	}

	/**
	 * Check if the local storage is available
	 * @returns {boolean}
	 */
	static isLocalStorageOn() {
		return 'undefined' !== typeof window.localStorage;
	}

}
